import { render, staticRenderFns } from "./SpMenuAccordion.vue?vue&type=template&id=efc72248&"
import script from "./SpMenuAccordion.vue?vue&type=script&lang=js&"
export * from "./SpMenuAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SpMenuAccordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports